import React from "react";

export const CompletedIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C11.866 1.5 15 4.63401 15 8.5C15 12.366 11.866 15.5 8 15.5ZM8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
        fill="#4CAF50"
      />
      <path
        d="M10.9697 5.46967C10.9626 5.47674 10.9559 5.48423 10.9498 5.4921L7.4774 9.91674L5.38388 7.82322C5.09098 7.53033 4.61611 7.53033 4.32322 7.82322C4.03032 8.11612 4.03032 8.59099 4.32322 8.88388L6.96966 11.5303C7.26256 11.8232 7.73743 11.8232 8.03032 11.5303C8.03685 11.5238 8.043 11.5169 8.04876 11.5097L12.041 6.51947C12.3232 6.22582 12.3196 5.75897 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export const CanceledIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C11.866 1.5 15 4.63401 15 8.5C15 12.366 11.866 15.5 8 15.5ZM8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
        fill="#F44336"
      />
      <path
        d="M11.3536 5.14645C11.1583 4.95118 10.8417 4.95118 10.6464 5.14645L4.64645 11.1464C4.45118 11.3417 4.45118 11.6583 4.64645 11.8536C4.84171 12.0488 5.15829 12.0488 5.35355 11.8536L11.3536 5.85355C11.5488 5.65829 11.5488 5.34171 11.3536 5.14645Z"
        fill="#F44336"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8.5C15 12.366 11.866 15.5 8 15.5C6.24696 15.5 4.64443 14.8556 3.41637 13.7907L13.2907 3.91637C14.3556 5.14443 15 6.74696 15 8.5ZM2.70926 13.0836L12.5836 3.20926C11.3556 2.14441 9.75304 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 10.253 1.64441 11.8556 2.70926 13.0836ZM16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5Z"
        fill="#F44336"
      />
    </svg>
  );
};

export const PendingIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.51496 1.51896C8.34401 1.50635 8.17225 1.5 8 1.5V0.5C8.19685 0.5 8.39314 0.507262 8.58852 0.521672L8.51496 1.51896ZM10.5193 1.96905C10.1985 1.84533 9.86912 1.7454 9.53371 1.67008L9.75282 0.694382C10.1361 0.780463 10.5126 0.894665 10.8792 1.03605L10.5193 1.96905ZM11.889 2.67971C11.7458 2.58402 11.5994 2.49388 11.4503 2.40939L11.9432 1.5393C12.1136 1.63586 12.2809 1.73888 12.4446 1.84824C12.6082 1.9576 12.7674 2.0727 12.9219 2.19322L12.3066 2.98158C12.1715 2.87612 12.0322 2.77541 11.889 2.67971ZM13.7231 4.46934C13.5252 4.18829 13.3068 3.92218 13.0697 3.67321L13.794 2.98368C14.0649 3.26821 14.3145 3.57233 14.5407 3.89353L13.7231 4.46934ZM14.4672 5.82122C14.4012 5.66208 14.3296 5.50583 14.2526 5.35271L15.1458 4.90311C15.2339 5.0781 15.3157 5.25667 15.391 5.43853C15.4664 5.62039 15.5348 5.80453 15.5962 5.99054L14.6467 6.30423C14.5929 6.14147 14.5331 5.98035 14.4672 5.82122ZM14.9979 8.32822C14.9895 7.98455 14.9557 7.64197 14.8969 7.30326L15.8822 7.13231C15.9494 7.51939 15.988 7.91092 15.9976 8.30367L14.9979 8.32822ZM14.8655 9.86563C14.8991 9.6967 14.9264 9.52699 14.9474 9.35687L15.9398 9.47929C15.9159 9.67372 15.8847 9.86766 15.8463 10.0607C15.8079 10.2538 15.7625 10.4449 15.7102 10.6337L14.7464 10.367C14.7922 10.2018 14.8319 10.0346 14.8655 9.86563ZM13.914 12.245C14.0979 11.9546 14.2602 11.651 14.3995 11.3367L15.3137 11.7419C15.1545 12.1011 14.969 12.4481 14.7588 12.78L13.914 12.245ZM12.9497 13.4497C13.0715 13.328 13.1885 13.202 13.3005 13.0722L14.0577 13.7254C13.9297 13.8737 13.796 14.0177 13.6569 14.1569L12.9497 13.4497Z"
        fill="#6F93EF"
      />
      <path
        d="M8 1.5C6.84885 1.5 5.71545 1.7839 4.70022 2.32655C3.68499 2.8692 2.81926 3.65386 2.17971 4.61101C1.54017 5.56816 1.14654 6.66827 1.03371 7.81388C0.920876 8.95949 1.09232 10.1153 1.53285 11.1788C1.97337 12.2423 2.66939 13.1808 3.55925 13.9111C4.44911 14.6414 5.50533 15.1409 6.63437 15.3655C7.76341 15.5901 8.93041 15.5327 10.032 15.1986C11.1336 14.8644 12.1358 14.2637 12.9497 13.4497L13.6569 14.1569C12.7266 15.0871 11.5812 15.7736 10.3223 16.1555C9.06332 16.5374 7.72961 16.6029 6.43928 16.3463C5.14895 16.0896 3.94183 15.5187 2.92486 14.6841C1.90788 13.8495 1.11243 12.7769 0.608966 11.5615C0.105504 10.346 -0.0904279 9.02514 0.0385242 7.71586C0.167476 6.40659 0.617333 5.14933 1.34825 4.05544C2.07916 2.96155 3.06857 2.0648 4.22883 1.44463C5.38909 0.824457 6.68439 0.5 8 0.5V1.5Z"
        fill="#6F93EF"
      />
      <path
        d="M7.5 3.5C7.77614 3.5 8 3.72386 8 4V9.20984L11.2481 11.0659C11.4878 11.2029 11.5711 11.5083 11.4341 11.7481C11.2971 11.9878 10.9917 12.0711 10.7519 11.9341L7.25193 9.93412C7.09615 9.8451 7 9.67943 7 9.5V4C7 3.72386 7.22386 3.5 7.5 3.5Z"
        fill="#6F93EF"
      />
    </svg>
  );
};

export const FailedIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C11.866 1.5 15 4.63401 15 8.5C15 12.366 11.866 15.5 8 15.5ZM8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
        fill="#F44336"
      />
      <path
        d="M4.64645 5.14645C4.84171 4.95118 5.15829 4.95118 5.35355 5.14645L8 7.79289L10.6464 5.14645C10.8417 4.95118 11.1583 4.95118 11.3536 5.14645C11.5488 5.34171 11.5488 5.65829 11.3536 5.85355L8.70711 8.5L11.3536 11.1464C11.5488 11.3417 11.5488 11.6583 11.3536 11.8536C11.1583 12.0488 10.8417 12.0488 10.6464 11.8536L8 9.20711L5.35355 11.8536C5.15829 12.0488 4.84171 12.0488 4.64645 11.8536C4.45118 11.6583 4.45118 11.3417 4.64645 11.1464L7.29289 8.5L4.64645 5.85355C4.45118 5.65829 4.45118 5.34171 4.64645 5.14645Z"
        fill="#F44336"
      />
    </svg>
  );
};

export const LoadingIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 15.5C2.22386 15.5 2 15.2762 2 15C2 14.7239 2.22386 14.5 2.5 14.5H3.5V13.5C3.5 11.7099 4.54528 10.1649 6.05655 9.4403C6.34645 9.3013 6.5 9.06317 6.5 8.85083V8.14919C6.5 7.93685 6.34645 7.69872 6.05655 7.55972C4.54528 6.83509 3.5 5.2901 3.5 3.5V2.5H2.5C2.22386 2.5 2 2.27614 2 2C2 1.72386 2.22386 1.5 2.5 1.5L13.5 1.50002C13.7761 1.50003 14 1.72389 14 2.00003C14 2.27617 13.7761 2.50003 13.5 2.50002L12.5 2.50001V3.5C12.5 5.2901 11.4547 6.83509 9.94345 7.55972C9.65355 7.69872 9.5 7.93685 9.5 8.14919V8.85083C9.5 9.06317 9.65355 9.3013 9.94345 9.4403C11.4547 10.1649 12.5 11.7099 12.5 13.5V14.5H13.5C13.7761 14.5 14 14.7239 14 15C14 15.2762 13.7761 15.5 13.5 15.5H2.5ZM4.5 2.50002V3.50002C4.5 4.0367 4.62078 4.54531 4.83678 5.00004H11.1632C11.3792 4.54531 11.5 4.0367 11.5 3.50002V2.50002H4.5ZM7.5 8.85085C7.5 9.55108 7.02187 10.0865 6.4889 10.342C5.31139 10.9066 4.5 12.1091 4.5 13.5C4.5 13.5 5.36574 12.2014 7.5 12.0208V8.85085ZM8.5 8.85085V12.0208C10.6343 12.2014 11.5 13.5 11.5 13.5C11.5 12.1091 10.6886 10.9066 9.5111 10.342C8.97813 10.0865 8.5 9.55108 8.5 8.85085Z"
        fill="#6F93EF"
      />
    </svg>
  );
};
